import { extractEventCalendarAssociationFromResponse } from './extractEventCalendarAssociationFromResponse';
import { getCalendarFoldersService } from '../services/getCalendarFoldersService';
import { initializeEventToCalendarAssociation } from './getEventToCalendarAssociation';
import { trace } from 'owa-trace';

/**
 * This utility populates the initial calendar event to calendar association data
 */
export const bootstrapEventToCalendarAssociation = async () => {
    try {
        const calendarFolderServiceResponse = await getCalendarFoldersService();

        const eventToCalendarAssociation = extractEventCalendarAssociationFromResponse(
            calendarFolderServiceResponse
        );

        initializeEventToCalendarAssociation(eventToCalendarAssociation);
    } catch (error) {
        trace.warn('Could not fetch get calendar folders service');
    }
};
